import * as React from 'react';
import { connect } from 'react-redux';

import { ButtonCheckbox } from '../../../../common/components/button_checkbox/index';
import { IAppState, Dispatch } from '../../../../common/state/app_state';
import { getTermValue } from '../../../../json_query/reducers/helpers';
import { changeIsDemolishedInMoscowProgramm } from '../../../state/advanced/demolished_in_moscow_programm';
import { InlineParam, Row } from '../markup';

interface IProps {
  value: boolean | undefined;
  onChange(value: boolean | undefined): void;
}

class DemolishedInMoscowProgramm extends React.PureComponent<IProps, {}> {
  public render() {
    const { value, onChange } = this.props;

    return (
      <Row title="Дома под снос">
        <InlineParam>
          <ButtonCheckbox
            value={value === false}
            onValueChange={onChange.bind(null, value === false ? undefined : false)}
          >
            Не показывать
          </ButtonCheckbox>
        </InlineParam>
        <InlineParam>
          <ButtonCheckbox value={value === true} onValueChange={onChange.bind(null, value === true ? undefined : true)}>
            Только под снос
          </ButtonCheckbox>
        </InlineParam>
      </Row>
    );
  }
}

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => ({
    value: getTermValue('demolished_in_moscow_programm')(state.filters.jsonQuery),
  }),
  (dispatch: Dispatch) => ({
    onChange: (value: boolean | undefined) => dispatch(changeIsDemolishedInMoscowProgramm(value)),
  }),
)(DemolishedInMoscowProgramm);
